import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'
export default {
    async create(model) {
        return await axios.post(`master-document`, model)
    },
    async fetchById(id) {
        return await axios.get(`master-document/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`master-document?q=${query}&page=${page}`)
       
    },
    async fetch_data(query,page,filters){
        return await axios.get(`master-document?q=${query}&page=${page}&${buildQuery(filters)}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`master-document/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`master-document/${id}`)
    },
    async fetchDocumentType(){
        return await axios.get('master-document/document-type-list');
    }
}
